import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { formatSeconds } from "@/lib/voice";

const Stat = ({ label, detail, credits, testId }) => (
  <div className="rounded-xl border border-white/[0.06] bg-ink-900 px-3.5 py-3" data-testid={testId}>
    <div className="text-[11px] uppercase tracking-[0.14em] text-zinc-500">{label}</div>
    <div className="mt-1 text-sm text-white">{credits} credits</div>
    {detail && <div className="text-xs text-zinc-500">{detail}</div>}
  </div>
);

export function VoiceUsage({ usage, balance, conversationId }) {
  const total = usage.listenCredits + usage.speakCredits + usage.replyCredits;
  return (
    <section className="rounded-2xl border border-white/[0.08] bg-ink-850 p-4 sm:p-5" data-testid="voice-usage">
      <div className="flex items-baseline justify-between gap-3">
        <h2 className="text-sm font-medium text-white">This session</h2>
        <span className="text-sm text-zinc-300" data-testid="voice-usage-total">{total} credits used</span>
      </div>
      <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-3">
        <Stat label="Listening" credits={usage.listenCredits} detail={usage.listenSeconds < 60 ? `${usage.listenSeconds.toFixed(1)} s` : formatSeconds(usage.listenSeconds)} testId="voice-usage-listening" />
        <Stat label="Speaking" credits={usage.speakCredits} detail={`${usage.speakChars.toLocaleString()} characters`} testId="voice-usage-speaking" />
        <Stat label="Answers" credits={usage.replyCredits} detail="chat rate" testId="voice-usage-answers" />
      </div>
      <div className="mt-3 flex flex-wrap items-center justify-between gap-2 text-xs text-zinc-500">
        <span data-testid="voice-usage-balance">{balance == null ? "" : `${balance.toLocaleString()} credits left`}</span>
        {conversationId && (
          <Link to={`/chat/${conversationId}`} className="inline-flex items-center gap-1 text-zinc-300 transition-colors hover:text-white" data-testid="voice-open-chat-link">
            Open this conversation in Chats <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
        )}
      </div>
    </section>
  );
}
